// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/marevo-menu-pivot-roof.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/img/marevo-menu-rectangle-roof.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/img/icons/checkbox-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/img/marevo-menu-back-wall.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/img/marevo-menu-freestanding.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/img/left-wall.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/img/right-wall.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/img/icons/checkbox.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.pickr {
  display: none !important;
}

.pcr-app {
  top: 50% !important;
  transform: translateY(-50%);
  left: auto !important;
  right: 40% !important;
  z-index: 99999;
}

.type_interface_radio-model {
  display: flex;
  justify-content: space-between;
  cursor: default;
  gap: 20px;
  margin-left: 5px;
}
.type_interface_radio-model_item {
  cursor: pointer !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 210px;
  height: fit-content;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}
.type_interface_radio-model_item--active {
  pointer-events: none;
}
.type_interface_radio-model_item--active:hover {
  transform: translateY(0) !important;
}
.type_interface_radio-model_item--active .type_interface_radio-model_option {
  border: 0.5px solid rgba(98, 154, 51, 0.7);
  box-shadow: 0px 0px 20px 0px rgba(11, 112, 162, 0.1);
}
.type_interface_radio-model_item--active .type_interface_radio-model_label {
  color: #629A33;
}
.type_interface_radio-model_option {
  cursor: pointer !important;
  padding: 4px;
  width: 210px;
  height: 110px;
  outline: 0;
  box-shadow: 0px 0px 20px 0px rgba(17, 17, 17, 0.1);
  transition: all 0.3s;
}
.type_interface_radio-model_option::after {
  content: "";
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  width: 100%;
  height: 100%;
}
.type_interface_radio-model_option--shade::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.type_interface_radio-model_option--blade::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.type_interface_radio-model_label {
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin-top: 10px;
}

.type_interface_checkbox-wall {
  display: flex;
  flex-direction: column;
  margin-left: 3px;
}
.type_interface_checkbox-wall .wrapp-wall-add-option {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.type_interface_checkbox-wall .wrapp-wall {
  display: flex;
  gap: 20px;
}
.type_interface_checkbox-wall_item {
  width: 210px;
  height: 143px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}
.type_interface_checkbox-wall_item.active:hover {
  transform: translateY(0) !important;
}
.type_interface_checkbox-wall_item.active .type_interface_checkbox-wall_option {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.type_interface_checkbox-wall_item.active .type_interface_checkbox-wall_item-img {
  border: 1px solid #629a33;
  box-shadow: 0px 0px 20px 0px rgba(11, 112, 162, 0.1);
}
.type_interface_checkbox-wall_item.active .type_interface_checkbox-wall_bottom label {
  color: #629A33;
}
.type_interface_checkbox-wall_item-img {
  cursor: pointer;
  box-shadow: 0px 0px 20px 0px rgba(17, 17, 17, 0.1);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 210px;
  height: 110px;
  display: flex;
}
.type_interface_checkbox-wall_item-img--back {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.type_interface_checkbox-wall_item-img--freeStanding {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.type_interface_checkbox-wall_item-img--left {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.type_interface_checkbox-wall_item-img--right {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.type_interface_checkbox-wall_option {
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding: 2px;
  display: none;
}
.type_interface_checkbox-wall_bottom {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.type_interface_post-size {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-left: 3px;
}
.type_interface_post-size_item {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 210px;
  height: fit-content;
  box-shadow: 0px 0px 20px 0px rgba(17, 17, 17, 0.1);
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  padding: 10px;
}
.type_interface_post-size_item--active {
  transition: all 0.3s;
  border: 0.5px solid #629a33;
  box-shadow: 0px 0px 20px 0px rgba(11, 112, 162, 0.1);
  color: #629A33;
}
.type_interface_post-size_item--active:hover {
  transform: translate(0) !important;
}
.type_interface_post-size_item label {
  cursor: pointer;
}
.type_interface_post-size_option {
  cursor: pointer;
}

.type_interface_colors-buttons .type_interface_post-size {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.type_interface_colors-buttons .type_interface_post-size_item {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: fit-content;
  box-shadow: 0px 0px 20px 0px rgba(17, 17, 17, 0.1);
  border-radius: 10px;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  padding: 10px;
  max-width: 210px;
}
.type_interface_colors-buttons .type_interface_post-size_item--active {
  transition: all 0.3s;
  border: 0.5px solid #629a33;
  box-shadow: 0px 0px 20px 0px rgba(11, 112, 162, 0.1);
  color: #629A33;
}
.type_interface_colors-buttons .type_interface_post-size_item--active:hover {
  transform: translate(0) !important;
}
.type_interface_colors-buttons .type_interface_post-size_item label {
  cursor: pointer;
}
.type_interface_colors-buttons .type_interface_post-size_option {
  cursor: pointer;
}

.type_interface_louvre-type {
  display: grid;
  justify-content: space-between;
  gap: 20px;
  grid-template-columns: 1fr 1fr;
  margin-left: 3px;
}
.type_interface_louvre-type_item {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 210px;
  height: fit-content;
  box-shadow: 0px 0px 20px 0px rgba(17, 17, 17, 0.1);
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  padding: 10px;
}
.type_interface_louvre-type_item--active {
  transition: all 0.3s;
  border: 0.5px solid #629a33;
  box-shadow: 0px 0px 20px 0px rgba(11, 112, 162, 0.1);
  color: #629A33;
}
.type_interface_louvre-type_item--active:hover {
  transform: translate(0) !important;
}
.type_interface_louvre-type_item label {
  cursor: pointer;
}
.type_interface_louvre-type_option {
  cursor: pointer;
  display: none;
}

.type_interface_colors-buttons {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.type_interface_colors-buttons .color-bottom {
  display: flex;
  gap: 20px;
  align-items: center;
}
.type_interface_colors-buttons .colors_picker_container {
  width: fit-content;
  gap: 20px;
  display: flex;
}
.type_interface_colors-buttons .colors_picker_container .colors_picker_color {
  width: 70px;
  height: 50px;
  cursor: pointer;
}
.type_interface_colors-buttons .colors_picker_container .colors_picker_button {
  width: 133px;
  height: 50px;
  cursor: pointer;
  color: #ffffff;
  font-family: "Inter", serif;
  border: none;
  outline: 0;
  background-color: #629A33;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  align-items: center;
  display: flex;
  justify-content: center;
  transition: all 0.3s;
}
.type_interface_colors-buttons .colors_picker_container .colors_picker_button:hover {
  background-color: #1A1A1A;
}
.type_interface_colors-buttons .colors_container {
  display: grid;
  gap: 16px;
}
.type_interface_colors-buttons .colors_container .add-info {
  font-size: 14px;
  font-weight: 400;
}
.type_interface_colors-buttons_item--active:hover {
  transform: translateY(0) !important;
}
.type_interface_colors-buttons_item--active .image-container {
  position: relative;
  padding: 2px;
  border: 0.5px solid rgba(98, 154, 51, 0.7) !important;
  box-shadow: 0px 0px 20px 0px rgba(98, 154, 51, 0.1);
}
.type_interface_colors-buttons_item--active .image-container::after {
  content: "";
  border: 0.5px solid #629a33 !important;
  position: absolute;
  width: 115%;
  height: 120%;
}
.type_interface_colors-buttons_item--active .type_interface_colors-buttons_label {
  color: #629A33;
}
.type_interface_colors-buttons_label {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  max-width: 70px;
}
.type_interface_colors-buttons_label .color-name {
  margin-top: 10px;
  text-align: center;
}
.type_interface_colors-buttons .image-container {
  width: 100%;
  height: 50px;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.5px solid rgba(98, 154, 51, 0.3);
  box-shadow: 0px 0px 20px 0px rgba(17, 17, 17, 0.1);
  transition: all 0.3s;
}
.type_interface_colors-buttons .image-container .color-image {
  width: 100%;
  height: 100%;
}

.type_interface_electronic {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
}
.type_interface_electronic_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: fit-content;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}
.type_interface_electronic_item_img {
  width: 95%;
}
.type_interface_electronic_item--active:hover {
  transform: translateY(0) !important;
}
.type_interface_electronic_item--active .image-container {
  border: 0.5px solid rgba(98, 154, 51, 0.7) !important;
  box-shadow: 0px 2px 10px 0px rgba(98, 154, 51, 0.3019607843) !important;
}
.type_interface_electronic_item--active .type_interface_colors-buttons_label {
  color: #629A33;
}
.type_interface_electronic_item--active .electronic-name::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
}
.type_interface_electronic_item--active .electronic-name {
  color: #629A33;
}
.type_interface_electronic_label {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.type_interface_electronic .electronic-name {
  margin-top: 16px;
  display: flex;
  align-items: center;
}
.type_interface_electronic .electronic-name::before {
  content: "";
  margin-right: 8px;
  display: flex;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 16px;
  height: 16px;
}
.type_interface_electronic .image-container {
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 210px;
  box-shadow: 0px 0px 20px 0px rgba(17, 17, 17, 0.1);
  transition: all 0.3s;
  padding: 4px;
  object-fit: cover;
  /* Покриває контейнер, як background-size: cover */
  object-position: center;
  position: relative;
}
.type_interface_electronic .image-container img {
  height: 100%;
  width: 100%;
}

.type_interface_roof-buttons {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  justify-content: center;
}
.type_interface_roof-buttons_item--active:hover {
  transform: translateY(0) !important;
}
.type_interface_roof-buttons_item--active .image-container {
  border: 0.5px solid rgba(98, 154, 51, 0.6) !important;
}
.type_interface_roof-buttons_item--active .type_interface_roof-buttons_label {
  color: #629A33;
}
.type_interface_roof-buttons_label {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}
.type_interface_roof-buttons_label .roof-name {
  margin-top: 10px;
}
.type_interface_roof-buttons .image-container {
  height: fit-content;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.5px solid rgba(98, 154, 51, 0.3);
  box-shadow: 0px 0px 20px 0px rgba(17, 17, 17, 0.1);
  transition: all 0.3s;
  padding: 3px;
}
.type_interface_roof-buttons .image-container .roof-image {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs.scss","webpack://./src/styles/_mixins.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACE,wBAAA;AADF;;AAIA;EACE,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AADF;AAGE;EACE,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;ECUF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ADVF;AAAI;EACE,oBAAA;AAEN;AAAM;EACE,mCAAA;AAER;AACM;ECvBJ,0CAAA;EAQA,oDAAA;ADkBF;AAEM;EACE,cEzCO;AFyCf;AAKE;EACE,0BAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EC/BF,kDAAA;EDiCE,oBAAA;AAHJ;AAKI;EACE,WAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AAHN;AAOM;EACE,yDAAA;AALR;AAUM;EACE,yDAAA;AARR;AAaE;ECpCA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;EDgCE,gBExEsB;AFmE1B;;AASA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AANF;AAUE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AARJ;AAWE;EACE,aAAA;EACA,SAAA;AATJ;AAYE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;ECxEF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AD+DF;AAUM;EACE,mCAAA;AARR;AAWM;EACE,yDAAA;AATR;AAYM;ECvGJ,yBAAA;EAIA,oDAAA;AD2FF;AAcQ;EACE,cE9HK;AFkHf;AAiBI;EACE,eAAA;EChHJ,kDAAA;EDkHI,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;AAfN;AAiBM;EACE,yDAAA;AAfR;AAkBM;EACE,yDAAA;AAhBR;AAmBM;EACE,yDAAA;AAjBR;AAoBM;EACE,yDAAA;AAlBR;AAuBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;AArBJ;AAwBE;EACE,gBErKsB;EFsKtB,aAAA;EACA,mBAAA;AAtBJ;;AA0BA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAvBF;AAyBE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EC3KF,kDAAA;EAeA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ED4JE,aAAA;AApBJ;AAsBI;EACE,oBAAA;ECzLJ,2BAAA;EAQA,oDAAA;EDoLI,cExMS;AFoLf;AAsBM;EACE,kCAAA;AApBR;AAwBI;EACE,eAAA;AAtBN;AA0BE;EACE,eAAA;AAxBJ;;AA8BE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AA3BJ;AA6BI;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EClNJ,kDAAA;EAIA,mBAAA;EAWA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EDoMI,aAAA;EACA,gBAAA;AAxBN;AA0BM;EACE,oBAAA;EClON,2BAAA;EAQA,oDAAA;ED6NM,cEjPO;AFyNf;AA0BQ;EACE,kCAAA;AAxBV;AA4BM;EACE,eAAA;AA1BR;AA8BI;EACE,eAAA;AA5BN;;AAiCA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,8BAAA;EACA,gBAAA;AA9BF;AAgCE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EC5PF,kDAAA;EAeA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ED6OE,aAAA;AA3BJ;AA6BI;EACE,oBAAA;EC1QJ,2BAAA;EAQA,oDAAA;EDqQI,cEzRS;AF8Pf;AA6BM;EACE,kCAAA;AA3BR;AA+BI;EACE,eAAA;AA7BN;AAiCE;EACE,eAAA;EACA,aAAA;AA/BJ;;AAmCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAhCF;AAkCE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAhCJ;AAmCE;EACE,kBAAA;EACA,SAAA;EACA,aAAA;AAjCJ;AAoCI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAlCN;AAqCI;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,cEjUQ;EDDZ,2BAAA;EDoUI,YAAA;EACA,UAAA;EACA,yBE1US;EF2UT,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;AAnCN;AAqCM;EACE,yBElVO;AF+Sf;AAwCE;EACE,aAAA;EACA,SAAA;AAtCJ;AAwCI;EACE,eAAA;EACA,gBAAA;AAtCN;AA4CM;EACE,mCAAA;AA1CR;AA6CM;EACE,kBAAA;EACA,YAAA;EChWN,qDAAA;EAQA,mDAAA;AD+SF;AA8CQ;EACE,WAAA;ECtWR,sCAAA;EDyWQ,kBAAA;EACA,WAAA;EACA,YAAA;AA7CV;AA6DM;EACE,cExYO;AF6Uf;AAgEE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EC9WF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ED6WE,eAAA;AA3DJ;AA6DI;EACE,gBAAA;EACA,kBAAA;AA3DN;AA+DE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ECrZF,0CAAA;EAQA,kDAAA;EDgZE,oBAAA;AA7DJ;AA+DI;EACE,WAAA;EACA,YAAA;AA7DN;;AAkEA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;AA/DF;AAiEE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;ECrZF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ADuVF;AA8DI;EACE,UAAA;AA5DN;AAgEM;EACE,mCAAA;AA9DR;AAiEM;ECxbJ,qDAAA;ED4bM,uEAAA;AAjER;AAoEM;EACE,cE5cO;AF0Yf;AAqEM;EACE,oEAAA;AAnER;AAsEM;EACE,cEpdO;AFgZf;AAyEE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAvEJ;AA0EE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAxEJ;AA2EE;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,yDAAA;EAEA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;AA1EJ;AA6EE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;ECreF,kDAAA;EDueE,oBAAA;EACA,YAAA;EACA,iBAAA;EACA,kDAAA;EACA,uBAAA;EAEA,kBAAA;AA5EJ;AA8EI;EACE,YAAA;EACA,WAAA;AA5EN;;AAiFA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,uBAAA;AA9EF;AAkFM;EACE,mCAAA;AAhFR;AAmFM;EC1gBJ,qDAAA;AD0bF;AAqFM;EACE,cE5hBO;AFycf;AAwFE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EClgBF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AD6aF;AAqFI;EACE,gBAAA;AAnFN;AAuFE;EACE,mBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ECtiBF,0CAAA;EAQA,kDAAA;EDiiBE,oBAAA;EACA,YAAA;AArFJ;AAuFI;EACE,WAAA;EACA,YAAA;AArFN","sourcesContent":["@use \"../../../../../styles/mixins\" as mixins;\n@use \"../../../../../styles/variables\" as vars;\n\n.pickr {\n  display: none !important;\n}\n\n.pcr-app {\n  top: 50% !important;\n  transform: translateY(-50%);\n  left: auto !important;\n  right: 40% !important;\n  z-index: 99999;\n}\n\n.type_interface_radio-model {\n  display: flex;\n  justify-content: space-between;\n  cursor: default;\n  gap: 20px;\n  margin-left: 5px;\n\n  &_item {\n    cursor: pointer !important;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 210px;\n    height: fit-content;\n    @include mixins.h3;\n\n    &--active {\n      pointer-events: none;\n\n      &:hover {\n        transform: translateY(0) !important;\n      }\n\n      .type_interface_radio-model_option {\n        @include mixins.box-border(10, rgba(vars.$second-color, 0.7));\n        @include mixins.box-shadow(#0b70a229);\n      }\n\n      .type_interface_radio-model_label {\n        color: vars.$second-color;\n      }\n    }\n  }\n\n  &_option {\n    cursor: pointer !important;\n    padding: 4px;\n    width: 210px;\n    height: 110px;\n    outline: 0;\n    @include mixins.box-shadow(#11111129);\n    transition: all 0.3s;\n\n    &::after {\n      content: \"\";\n      background-repeat: no-repeat;\n      background-size: cover;\n      background-position: center;\n      display: flex;\n      width: 100%;\n      height: 100%;\n    }\n\n    &--shade {\n      &::after {\n        background-image: url(/public/img/marevo-menu-pivot-roof.png);\n      }\n    }\n\n    &--blade {\n      &::after {\n        background-image: url(/public/img/marevo-menu-rectangle-roof.png);\n      }\n    }\n  }\n\n  &_label {\n    @include mixins.h4();\n    margin-top: vars.$margin-top-title-option;\n  }\n}\n\n.type_interface_checkbox-wall {\n  display: flex;\n  flex-direction: column;\n  margin-left: 3px;\n  // gap: 20px;\n  // justify-content: space-between;\n\n  .wrapp-wall-add-option {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n  }\n\n  .wrapp-wall {\n    display: flex;\n    gap: 20px\n  }\n\n  &_item {\n    width: 210px;\n    height: 143px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    @include mixins.h3;\n\n    &.active {\n      &:hover {\n        transform: translateY(0) !important;\n      }\n\n      .type_interface_checkbox-wall_option {\n        background-image: url(/public/img/icons/checkbox-active.svg);\n      }\n\n      .type_interface_checkbox-wall_item-img {\n        @include mixins.box-border-solid(10, rgba(vars.$second-color, 1));\n        @include mixins.box-shadow(#0b70a229);\n      }\n\n      .type_interface_checkbox-wall_bottom {\n        label {\n          color: vars.$second-color;\n        }\n      }\n    }\n\n    &-img {\n      cursor: pointer;\n      @include mixins.box-shadow(#11111129);\n      background-repeat: no-repeat;\n      background-size: contain;\n      background-position: center;\n      width: 210px;\n      height: 110px;\n      display: flex;\n\n      &--back {\n        background-image: url(/public/img/marevo-menu-back-wall.png);\n      }\n\n      &--freeStanding {\n        background-image: url(/public/img/marevo-menu-freestanding.png);\n      }\n\n      &--left {\n        background-image: url(/public/img/left-wall.svg);\n      }\n\n      &--right {\n        background-image: url(/public/img/right-wall.svg);\n      }\n    }\n  }\n\n  &_option {\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n    margin-right: 8px;\n    background-image: url(/public/img/icons/checkbox.svg);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    padding: 2px;\n    display: none;\n  }\n\n  &_bottom {\n    margin-top: vars.$margin-top-title-option;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.type_interface_post-size {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  margin-left: 3px;\n\n  &_item {\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 210px;\n    height: fit-content;\n    @include mixins.box-shadow(#11111129);\n    @include mixins.h3;\n    padding: 10px;\n\n    &--active {\n      transition: all 0.3s;\n      @include mixins.box-border(10, rgba(vars.$second-color, 1));\n      @include mixins.box-shadow(#0b70a229);\n      color: vars.$second-color;\n\n      &:hover {\n        transform: translate(0) !important;\n      }\n    }\n\n    label {\n      cursor: pointer;\n    }\n  }\n\n  &_option {\n    cursor: pointer;\n  }\n}\n\n//POST SIZE BUTTON STYLES IN COLOR\n.type_interface_colors-buttons {\n  .type_interface_post-size {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n\n    &_item {\n      cursor: pointer;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      width: 100%;\n      height: fit-content;\n      @include mixins.box-shadow(#11111129);\n      @include mixins.radius;\n      @include mixins.h3;\n      padding: 10px;\n      max-width: 210px;\n\n      &--active {\n        transition: all 0.3s;\n        @include mixins.box-border(10, rgba(vars.$second-color, 1));\n        @include mixins.box-shadow(#0b70a229);\n        color: vars.$second-color;\n\n        &:hover {\n          transform: translate(0) !important;\n        }\n      }\n\n      label {\n        cursor: pointer;\n      }\n    }\n\n    &_option {\n      cursor: pointer;\n    }\n  }\n}\n\n.type_interface_louvre-type {\n  display: grid;\n  justify-content: space-between;\n  gap: 20px;\n  grid-template-columns: 1fr 1fr;\n  margin-left: 3px;\n\n  &_item {\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 210px;\n    height: fit-content;\n    @include mixins.box-shadow(#11111129);\n    @include mixins.h3;\n    padding: 10px;\n\n    &--active {\n      transition: all 0.3s;\n      @include mixins.box-border(10, rgba(vars.$second-color, 1));\n      @include mixins.box-shadow(#0b70a229);\n      color: vars.$second-color;\n\n      &:hover {\n        transform: translate(0) !important;\n      }\n    }\n\n    label {\n      cursor: pointer;\n    }\n  }\n\n  &_option {\n    cursor: pointer;\n    display: none;\n  }\n}\n\n.type_interface_colors-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n\n  .color-bottom {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n  }\n\n  .colors_picker_container {\n    width: fit-content;\n    gap: 20px;\n    display: flex;\n\n\n    .colors_picker_color {\n      width: 70px;\n      height: 50px;\n      cursor: pointer;\n    }\n\n    .colors_picker_button {\n      width: 133px;\n      height: 50px;\n      cursor: pointer;\n      color: vars.$white-color;\n      @include mixins.font-family();\n      border: none;\n      outline: 0;\n      background-color: vars.$second-color;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 100%;\n      letter-spacing: 0%;\n      align-items: center;\n      display: flex;\n      justify-content: center;\n      transition: all 0.3s;\n\n      &:hover {\n        background-color: vars.$black-color;\n      }\n    }\n  }\n\n  .colors_container {\n    display: grid;\n    gap: 16px;\n\n    .add-info {\n      font-size: 14px;\n      font-weight: 400;\n    }\n  }\n\n  &_item {\n    &--active {\n      &:hover {\n        transform: translateY(0) !important;\n      }\n\n      .image-container {\n        position: relative;\n        padding: 2px;\n        @include mixins.box-border(10,\n          rgba(vars.$second-color, 0.7) !important);\n        @include mixins.box-shadow(#629A334D);\n\n        &::after {\n          content: \"\";\n          @include mixins.box-border(10,\n            rgba(vars.$second-color, 1) !important);\n          position: absolute;\n          width: 115%;\n          height: 120%;\n        }\n\n        // &::before {\n        //   content: \"\";\n        //   @include mixins.box-border(\n        //     10,\n        //     rgba(vars.$second-color, 1) !important\n        //   );\n        //   position: absolute;\n        //   width: 50px;\n        //   height: 50px;\n        //   border-radius: 50%;\n        // }\n      }\n\n      .type_interface_colors-buttons_label {\n        color: vars.$second-color;\n      }\n    }\n  }\n\n  &_label {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    @include mixins.h3;\n    max-width: 70px;\n\n    .color-name {\n      margin-top: 10px;\n      text-align: center;\n    }\n  }\n\n  .image-container {\n    width: 100%;\n    height: 50px;\n    padding: 3px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    @include mixins.box-border(10, rgba(vars.$second-color, 0.3));\n    @include mixins.box-shadow(#1111111a);\n    transition: all 0.3s;\n\n    .color-image {\n      width: 100%;\n      height: 100%;\n    }\n  }\n}\n\n.type_interface_electronic {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  width: 100%;\n\n  &_item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    height: fit-content;\n    @include mixins.h3;\n\n    &_img {\n      width: 95%;\n    }\n\n    &--active {\n      &:hover {\n        transform: translateY(0) !important;\n      }\n\n      .image-container {\n        @include mixins.box-border(10,\n          rgba(vars.$second-color, 0.7) !important);\n\n        box-shadow: 0px 2px 10px 0px #629A334D !important;\n      }\n\n      .type_interface_colors-buttons_label {\n        color: vars.$second-color;\n      }\n\n      .electronic-name::before {\n        background-image: url(/public/img/icons/checkbox-active.svg) !important;\n      }\n\n      .electronic-name {\n        color: vars.$second-color;\n      }\n    }\n  }\n\n  &_label {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n  }\n\n  .electronic-name {\n    margin-top: 16px;\n    display: flex;\n    align-items: center;\n  }\n\n  .electronic-name::before {\n    content: \"\";\n    margin-right: 8px;\n    display: flex;\n    background-image: url(/public/img/icons/checkbox.svg);\n    // background-image: url(/public/img/icons/checkbox-active.svg);\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n    width: 16px;\n    height: 16px;\n  }\n\n  .image-container {\n    height: 110px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 210px;\n    @include mixins.box-shadow(#11111129);\n    transition: all 0.3s;\n    padding: 4px;\n    object-fit: cover;\n    /* Покриває контейнер, як background-size: cover */\n    object-position: center;\n\n    position: relative;\n\n    img {\n      height: 100%;\n      width: 100%;\n    }\n  }\n}\n\n.type_interface_roof-buttons {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  justify-content: center;\n\n  &_item {\n    &--active {\n      &:hover {\n        transform: translateY(0) !important;\n      }\n\n      .image-container {\n        @include mixins.box-border(10,\n          rgba(vars.$second-color, 0.6) !important);\n      }\n\n      .type_interface_roof-buttons_label {\n        color: vars.$second-color;\n      }\n    }\n  }\n\n  &_label {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    @include mixins.h3;\n\n    .roof-name {\n      margin-top: 10px;\n    }\n  }\n\n  .image-container {\n    height: fit-content;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    @include mixins.box-border(10, rgba(vars.$second-color, 0.3));\n    @include mixins.box-shadow(#1111111a);\n    transition: all 0.3s;\n    padding: 3px;\n\n    .roof-image {\n      width: 100%;\n      height: 100%;\n    }\n  }\n}","@use \"variables\" as vars;\n\n@mixin text-center {\n  text-align: center;\n}\n\n@mixin font-family {\n  font-family: \"Inter\", serif;\n}\n\n@mixin font-family-second {\n   font-family: \"Inter\", serif;\n}\n\n@mixin box-border($blur, $color) {\n  border: 0.5px solid $color;\n}\n\n@mixin box-border-solid($blur, $color) {\n  border: 1px solid $color;\n}\n\n@mixin box-shadow($color) {\n  box-shadow: 0px 0px 20px 0px rgba($color, 0.1);\n}\n\n@mixin radius() {\n  border-radius: 10px;\n}\n\n@mixin h2() {\n  font-family: \"Inter\", serif;\n  font-weight: 300;\n  font-size: 17px;\n  line-height: 100%;\n}\n\n@mixin h3() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n}\n\n@mixin h4() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin h5() {\n  font-family: \"Inter\", serif;\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin bold {\n  font-family: \"Inter\", serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n}\n","$primary-color: #629A33;\n$secondary-color: #6c757d;\n$font-size-base: 16px;\n$second-color: #629A33;\n$second-color-1: #06aeef;\n$shadow-color: #47659314;\n$black-color:  #1A1A1A;\n$black-color-second: #3A3A3C;\n$white-color: #ffffff;\n$red-color: #ff214a;\n\n$margin-top-title-option: 10px;\n$padding-vertical-group-inputs: 20px;\n$width-interface: 39vw;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
